import { Component, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { CallService } from './services/call.service';
import { IncomingCallDialogComponent } from './pages/support/call/incoming-call-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'hit2Open';

  constructor(
    private callService: CallService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token) {
      const adminId = localStorage.getItem('managerId') || '';
      const role = localStorage.getItem('role') || '';
      const name = localStorage.getItem('name') || 'Admin';
      this.callService.connect(adminId, role, name);

      this.callService.incomingCall$.subscribe(callInfo => {
        this.dialogService.open(IncomingCallDialogComponent, {
          context: {
            callId: callInfo.callId,
            callerName: callInfo.callerName,
            callerRole: callInfo.callerRole
          }
        });
      });
    }
  }
}
